var _a;
import imgSrc from '@images/marketing/PDPs/Sally.jpg';
import { MealName } from '@marketing/content';
var title = 'Sally Perea, DVM';
var imageData = {
    src: imgSrc,
    alt: 'A woman hugs her dog',
};
var tickerText = 'from our vet';
export var vetApprovedSectionContent = (_a = {},
    _a[MealName.Chicken] = {
        title: title,
        imageData: imageData,
        tickerText: tickerText,
        quote: '“Chicken Cuisine is a nutrient-rich formula, packed with ingredients that support health across all life stages.”',
        backgroundColorStyle: 'bg-action-surface-primary',
        theme: 'light',
    },
    _a[MealName.Beef] = {
        title: title,
        imageData: imageData,
        tickerText: tickerText,
        quote: '“Beef Mash is a favorite for dogs who enjoy a meaty blend that also satisfies their nutritional needs.”',
        backgroundColorStyle: 'bg-deco-pink',
        theme: 'light',
    },
    _a[MealName.Turkey] = {
        title: title,
        imageData: imageData,
        tickerText: tickerText,
        quote: '“Turkey Fare delivers a highly digestible, high-quality turkey and egg combination.”',
        backgroundColorStyle: 'bg-deco-green',
        theme: 'dark',
    },
    _a[MealName.Pork] = {
        title: title,
        imageData: imageData,
        tickerText: tickerText,
        quote: '“Pork Potluck is a great go-to recipe when looking for single protein alternative to chicken or beef.”',
        backgroundColorStyle: 'bg-deco-dark-blue',
        theme: 'dark',
    },
    _a[MealName.Lamb] = {
        title: title,
        imageData: imageData,
        tickerText: tickerText,
        quote: '“Lamb Pilaf is a new favorite, with a highly digestible lamb and rice blend that dogs love.”',
        backgroundColorStyle: 'bg-deco-dark-purple',
        theme: 'dark',
    },
    _a[MealName.TurkeyChicken] = {
        title: title,
        imageData: imageData,
        tickerText: tickerText,
        quote: '“Turkey & Chicken Cookout brings together two complementary proteins, plus egg, for a delicious balance of amino acids.”',
        backgroundColorStyle: 'bg-deco-green',
        theme: 'dark',
    },
    _a);
